// extracted by mini-css-extract-plugin
export default {"header":"styles_header__-+xew","headerCircle":"styles_headerCircle__5zQqs"};